import { Box, Typography } from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import React from 'react';
import { useTranslation } from 'react-i18next';

const WarningAdvancedVoice = () => {
  const { i18n } = useTranslation();
  const { t } = i18n;

  return (
    <Box className="warining-advanced-voice-container">
      <WarningRoundedIcon sx={{ fontSize: 24 }} color="warning" />
      <Typography className="warning-text">
        {t('wariningAdvancedVoiceForOldCredit')}
      </Typography>
    </Box>
  );
};

export default WarningAdvancedVoice;
